import React, { Component } from 'react';
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import PrincipalLeaveLanding from '../Components/PrincipalLeave/PrincipalLeaveLanding';

class LeaveGrantContainer extends Component {
    constructor(props) {
        super(props);

        let us = JSON.parse(localStorage.getItem('user'));
        let username = us.user.id;
        let name = us.user.name;

        this.state = {
            username: username,
            apikey: us.user.apikey,
            name: name
        }

    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} username={this.state.username} apikey={this.state.apikey} />
                <div className="main-body">
                    <PrincipalLeaveLanding
                        history={this.props.history}
                        username={this.state.username}
                        name={this.state.name}
                        apikey={this.state.apikey} />
                </div>
            </div>
        )
    }
}

export default withAuth(LeaveGrantContainer);